import { render, staticRenderFns } from "./ChargebeeUpsellSettingsSummary.vue?vue&type=template&id=ce5c4a1a&scoped=true&"
import script from "./ChargebeeUpsellSettingsSummary.vue?vue&type=script&lang=js&"
export * from "./ChargebeeUpsellSettingsSummary.vue?vue&type=script&lang=js&"
import style0 from "./ChargebeeUpsellSettingsSummary.vue?vue&type=style&index=0&id=ce5c4a1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5c4a1a",
  null
  
)

export default component.exports